module.exports = __webpack_public_path__ + "static/dcac6c49-b276-4cce-a484-21360dbf8614-500.bd7a31c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/angel/dcac6c49-b276-4cce-a484-21360dbf8614-500.jpg
// module id = 846
// module chunks = 168707334958949